import Vue from 'vue';

// Domain
import { CustomerInvestorGoalBalanceStateManager } from '../../domain/state/customer-investor-goal-balance-state-manager';
import CustomerInvestorGoalBalanceState from '../../domain/state/customer-investor-goal-balance-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class CustomerInvestorGoalBalanceVueStateManager
implements CustomerInvestorGoalBalanceStateManager {
  // eslint-disable-next-line max-len
    private _state: CustomerInvestorGoalBalanceState = Vue.observable<CustomerInvestorGoalBalanceState>(
      new CustomerInvestorGoalBalanceState(),
    );

    private readonly observers: Observer[] = [];

    get state(): CustomerInvestorGoalBalanceState {
      return this._state;
    }

    set state(value: CustomerInvestorGoalBalanceState) {
      this._state = value;
    }

    patch(state: Partial<CustomerInvestorGoalBalanceState>) {
      type Keys = keyof CustomerInvestorGoalBalanceState;
      Object.entries(state).forEach(([key, value]) => {
        const accessor = key as Keys;
        if (value !== undefined) {
          // eslint-disable-next-line
          // @ts-ignore @typescript-eslint/ban-ts-ignore
          this.state[accessor] = value;
        }
      });
    }

    notifyAll(): void {
      this.observers.forEach((observer) => observer.notify());
    }

    register(observer: Observer): void {
      this.observers.push(observer);
    }
}
